import { App, Form } from 'antd';
import { useEffect, useState } from 'react';

import { webhooksActions } from '@store/webhooks/webhooks.slice';

import { initialNewApplicationForm } from '@form/new-consumer/new-consumer.form-initial';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { useAddWebhookMutation } from '@hook/webhook/webhook.hooks';
import { AddConsumerInterface } from '@interface/consumer/consumer.interface';
import { WebhookStatusEnum } from '@interface/webhook/webhook.interface';

export const useNewWebhook = () => {
  const { current } = useCurrentApplication();
  const { action, state } = useMutation(useAddWebhookMutation(), webhooksActions, webhooksActions.setWebhook);
  const isLoading = useStoreSelector((state) => state.consumers.isLoading);
  const error = useStoreSelector((state) => state.webhooks.error);
  const [isModalOpen, setModalOpen] = useState(false);
  const { message } = App.useApp();
  const [form] = Form.useForm<AddConsumerInterface>();
  const { isViewer } = useMemberRole();

  const onFinish = async () => {
    const values = await form.validateFields();

    const newValues = { ...initialNewApplicationForm, ...values, application: current.id };

    action({ ...newValues, status: newValues.status ? WebhookStatusEnum.Enabled : WebhookStatusEnum.Disabled });
  };

  const onOpenModal = () => !isViewer && setModalOpen(true);
  const onCloseModal = () => setModalOpen(false);

  useEffect(() => {
    if (state.isSuccess) {
      message.success('Webhook was successfully added');
      form.resetFields();
      onCloseModal();
    }
  }, [state.isSuccess, message, form]);

  return {
    form,
    isLoading,
    isModalOpen,
    error,
    onFinish,
    onOpenModal,
    onCloseModal,
    shouldEdit: !isViewer,
  };
};
